<template>
  <div>
    <div
      v-if="label"
      class="mb-1 text-left text-xs font-bold uppercase text-dark-gray"
    >
      {{ label }}
    </div>
    <div
      class="flex flex-grow rounded-md border border-transparent bg-gray-100 focus-within:border-placeholder-gray hover:border-placeholder-gray"
      :class="{ activeButton: isChecked }"
      style="min-height: 4rem"
    >
      <label
        class="container text-base"
        :class="{ activeButtonText: isChecked }"
      >
        <span class="text-align text-xs">
          <slot />
        </span>
        <span
          class="checkbox-checkmark"
          :class="{
            'bg-yellow-500': isChecked,
            'bg-white': !isChecked,
            [positionCheckmark]: true,
          }"
        >
          <input
            type="checkbox"
            tabindex="2"
            :name="name"
            :value="value"
            :checked="isChecked"
            @click="toggleCheck"
          />
        </span>
      </label>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  value: String,
  label: { type: String, default: '' },
  name: [String, Number],
  notice: { type: String, default: '' },
  modelValue: Boolean,
  positionCheckmark: { type: String, default: 'top-2' },
});

const emit = defineEmits(['update:modelValue']);

const isChecked = ref(props.modelValue);

const toggleCheck = () => {
  isChecked.value = !isChecked.value;
  emit('update:modelValue', isChecked.value);
};

watch(
  () => props.modelValue,
  (newValue) => {
    isChecked.value = newValue;
  }
);
</script>

<style scoped>
.container {
  @apply relative flex h-auto cursor-pointer items-center text-left text-xs text-body-color sm:text-sm;
  user-select: none;
}

.container input {
  @apply absolute h-0 w-0 cursor-pointer opacity-0;
}

.checkbox-checkmark {
  @apply absolute left-2 h-6 w-6 rounded-md;
}

.checkbox-checkmark.bg-yellow-500:after {
  display: block;
}

.checkbox-checkmark:after {
  content: '';
  position: absolute;
  left: 8px;
  top: 3px;
  width: 9px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.activeButton {
  @apply flex flex-wrap rounded-md border border-yellow-500 bg-white;
  border-color: #f8c617 !important;
}

.activeButtonText {
  @apply text-dark-gray;
}
</style>
